import React, { useEffect, useState } from "react";
import { supabase } from "../../supabaseClient.js";
import "../../styles/ItemsMaster.css"; // ⬅️ using your CSS file

const ItemsMaster = () => {
  const [items, setItems] = useState([]);
  const [item_name, setItemName] = useState("");
  const [editId, setEditId] = useState(null);

  // Fetch Items
  const fetchItems = async () => {
    const { data, error } = await supabase
      .from("ITEMS")
      .select("*")
      .order("item_name", { ascending: true });

    if (!error) setItems(data);
  };

  useEffect(() => {
    fetchItems();
  }, []);

  // Save / Update
  const saveItem = async () => {
    if (!item_name.trim()) return alert("Enter Item Name!");

    if (editId) {
      await supabase.from("ITEMS").update({ item_name }).eq("id", editId);
      setEditId(null);
    } else {
      await supabase.from("ITEMS").insert([{ item_name }]);
    }

    setItemName("");
    fetchItems();
  };

  // Edit
  const editItem = (i) => {
    setItemName(i.item_name);
    setEditId(i.id);
  };

  // Delete
  const deleteItem = async (id) => {
    if (window.confirm("Delete this item?")) {
      await supabase.from("ITEMS").delete().eq("id", id);
      fetchItems();
    }
  };

  return (
    <div className="itemsMasterContainer">

      {/* PAGE TITLE */}
      <h2 className="pageTitle">📦 Items Master</h2>

      {/* FORM BOX */}
      <div className="formCard">
        <h3 className="formTitle">{editId ? "✏️ Edit Item" : "➕ Add Item"}</h3>

        <div className="formRow">
          <input
            type="text"
            className="inputField"
            placeholder="Enter Item Name"
            value={item_name}
            onChange={(e) => setItemName(e.target.value)}
          />

          <button className="saveBtn" onClick={saveItem}>
            {editId ? "Update" : "Save"}
          </button>
        </div>
      </div>

      {/* TABLE */}
      <table className="styledTable">
        <thead>
          <tr>
            <th>Item Name</th>
            <th style={{ width: "180px" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {items.map((i) => (
            <tr key={i.id}>
              <td>{i.item_name}</td>
              <td>
                <div className="action-buttons">
                  <button className="btn-edit" onClick={() => editItem(i)}>
                    Edit
                  </button>
                  <button className="btn-delete" onClick={() => deleteItem(i.id)}>
                    Delete
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

    </div>
  );
};

export default ItemsMaster;
